export default "__VITE_ASSET__DbyBPn5f__"